import { LessonType } from '../../content/models/LessonVm';

class LessonService {
  public isNative(type: LessonType) {
    return (
      type === 'unknown' || //* for backward compatibility
      type === 'lesson' ||
      type === 'quiz' ||
      type === 'assessment'
    );
  }
}

export default new LessonService();
